import { Injectable } from "@angular/core";
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';

import { BaseWebService } from "../shared/services/base-web.service";
import 'rxjs/add/observable/throw';

@Injectable()
export class VCPhotoService {

    constructor(
        private _basewebservice: BaseWebService
    ) { }

    uploadPhoto(formData: any, token: any) {
        const data: any = {};
        data.body = formData;
        data.token = token;
        return this._basewebservice.requestFormDataWithUrlToken("v1/va/image/", "post", data)
            .map((res: any) => res)
            .catch(this.handleError);
    }

    /**
     * Function for handling service call errors
     * @param  {Response|any} error contains error data
     */
    handleError(error: Response | any) {
        return Observable.throw(error);
    }

}